export default __webpack_public_path__ + "static/media/img-cluster-type-zero-state.406c975a.svg";